import React from 'react';
import { Button } from '../../../components/tailwind/button';
import { Loader2, Save, ArrowLeft } from 'lucide-react';

export default function TemplatePageHeader({ onSubmit, loading, onBack, onDiscard }) {
  return (
    <div className="flex items-center justify-between mb-6 gap-3">
      <Button
        variant="ghost"
        size="icon"
        className="text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white shrink-0"
        onClick={onBack}
        aria-label="Back"
      >
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <div className="flex gap-3 ml-auto">
        <Button
          variant="outline"
          className="bg-white dark:bg-slate-900 text-gray-700 dark:text-gray-300"
          onClick={onDiscard}
        >
          Discard
        </Button>
        <Button
          className="bg-[hsl(158,48%,36%)] hover:bg-[hsl(158,48%,30%)] text-white font-semibold cursor-pointer gap-2"
          onClick={onSubmit}
          disabled={loading}
          aria-busy={loading}
        >
          {loading ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Submitting...
            </>
          ) : (
            <>
              <Save className="h-4 w-4" />
              Submit for Approval
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
